import React, { useContext, useEffect,  useState } from "react";
import { MyThemeContext } from "../context/theme-context";

// import Header from "../components/Header/Header";
// import LoadingWebSite from "../components/Common/LoadingWebSite";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
// import SavingsIcon from "@mui/icons-material/Savings";
// import BusinessIcon from "@mui/icons-material/Business";

import { blue, grey } from "@mui/material/colors";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AppNav from "../components/AppNav";

const TITLE = "Vérif Scores Quilles de Huit - About";

function About() {
	const { FRONT_END_NAME, FRONT_END_VERSION } = useContext(MyThemeContext);
	const [localStorageUsed, setLocalStorageUsed] = useState(0);
	const [sessionStorageUsed, setSessionStorageUsed] = useState(0);

	useEffect(() => {
		document.title = TITLE;
	}, []);

	useEffect(() => {
		const getStorageUsage = () => {
			const localStorageBytes = JSON.stringify(localStorage).length;
			const sessionStorageBytes = JSON.stringify(sessionStorage).length;
			const localStorageTotal = 5 * 1024 * 1024; // 5 MB by default
			const sessionStorageTotal = 5 * 1024 * 1024; // 5 MB by default
			setLocalStorageUsed(localStorageTotal - localStorageBytes);
			setSessionStorageUsed(sessionStorageTotal - sessionStorageBytes);
		};

		// console.log(window.sessionStorage)

		getStorageUsage();

		// Add event listeners to update storage usage if storage changes
		window.addEventListener("storage", getStorageUsage);

		// Cleanup by removing event listeners
		return () => {
			window.removeEventListener("storage", getStorageUsage);
		};
	}, []);

	return (
    <Box>
      <AppNav />
      {/* <Header /> */}
        <Box>
          {/* Introduction */}
          <Box>
            <Box sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <Box sx={{ pt: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                {/* <Avatar alt='Logo' src='/logo-pitsbi2.png' sx={{ ml: 1, width: 30, height: 40 }} /> */}
                <Typography variant='h4' sx={{ mx: 5 }} color={blue[700]}>
                  {FRONT_END_NAME}
                </Typography>
                {/* <Avatar alt='Logo' src='/logo-pitsbi2.png' sx={{ ml: 1, width: 30, height: 40 }} /> */}
              </Box>
              <Typography variant='h5' sx={{ m: 0 }} color={blue[700]}>
                version {FRONT_END_VERSION}
              </Typography>
              <Typography variant='body1' align='center' sx={{ p: 1 }} color={blue[700]}>
                <strong>{FRONT_END_NAME}</strong> vous permet de consulter la date du fichier de scores à remettre le <strong>dimanche soir</strong> par district.
              </Typography>
              <Typography variant='body2' sx={{ mt: 0 }} style={{ fontStyle: 'italic' }} color={grey[500]}>
                LocalStorage free: {localStorageUsed.toLocaleString()} bytes - sessionStorage free: {sessionStorageUsed.toLocaleString()} bytes
              </Typography>
            </Box>
          </Box>

          {/* Referrals */}
          {/* <Box>
            <Box sx={{ mt: 3, p: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <Box sx={{ pt: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Avatar alt='Logo' src='/logo-pitsbi2.png' sx={{ ml: 1, width: 30, height: 40 }} />
                <Box sx={{ pt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography variant='h3' sx={{ mx: 5 }} color={blue[700]}>
                    Pit's BI Referrals
                  </Typography>
                  <Typography variant='h6' sx={{ mx: 5 }} color={blue[700]}>
                    Other investment platforms and partners website
                  </Typography>
                </Box>
                <Avatar alt='Logo' src='/logo-pitsbi2.png' sx={{ ml: 1, width: 30, height: 40 }} />
              </Box>

              <Box sx={{ pt: 1, display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                <IconButton onClick={() => handleReferalURLClick(referalURL_RentTracker)}>
                  <Avatar
                    alt={'RentTrackerLogo'}
                    src={RentTrackerLogo}
                    fontSize='small'
                    sx={{ width: 200, height: 80 }}
                    imgProps={{ style: { objectFit: 'contain', height: '50%', width: 'auto' } }}
                  />
                </IconButton>
                <IconButton onClick={() => handleReferalURLClick(referalURL_GnosisCard)}>
                  <Avatar
                    alt={'GnosisCardLogo'}
                    src={GnosisCardLogo}
                    fontSize='small'
                    sx={{ width: 200, height: 80 }}
                    imgProps={{ style: { objectFit: 'contain', height: '55%', width: 'auto' } }}
                  />
                </IconButton>
                <IconButton onClick={() => handleReferalURLClick(referalURL_BienPreter)}>
                  <Avatar
                    alt={'BienPreterLogo'}
                    src={BienPreterLogo}
                    fontSize='small'
                    sx={{ width: 200, height: 80 }}
                    imgProps={{ style: { objectFit: 'contain', height: '69%', width: 'auto' } }}
                  />
                </IconButton>
                <IconButton onClick={() => handleReferalURLClick(referalURL_realT)}>
                  <Avatar
                    alt={'RealTLogo'}
                    src={RealTLogo}
                    fontSize='small'
                    sx={{ width: 200, height: 80 }}
                    imgProps={{ style: { objectFit: 'contain', height: '95%', width: 'auto' } }}
                  />
                </IconButton>
                <IconButton onClick={() => handleReferalURLClick(referalURL_MtPelerin)}>
                  <Avatar
                    alt={'MtPelerinLogo'}
                    src={MtPelerinLogo}
                    fontSize='small'
                    sx={{ width: 200, height: 80 }}
                    imgProps={{ style: { objectFit: 'contain', height: '65%', width: 'auto' } }}
                  />
                </IconButton>
                <IconButton onClick={() => handleReferalURLClick(referalURL_Community)}>
                  <Avatar
                    alt={'CommunityLogo'}
                    src={CommunityLogo}
                    fontSize='small'
                    sx={{ width: 200, height: 80 }}
                    imgProps={{ style: { objectFit: 'contain', height: '80%', width: 'auto' } }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box> */}

          {/* Version */}
          <Box>
            <Box sx={{ mt: 3, p: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: 0 }}>
              <Box sx={{ pt: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                {/* <Avatar alt='Logo' src='/logo-pitsbi2.png' sx={{ ml: 1, width: 30, height: 40 }} /> */}
                <Typography variant='h4' sx={{ mx: 5 }} color={blue[700]}>
                  Suivi des mises à jour sur le site
                </Typography>
                {/* <Avatar alt='Logo' src='/logo-pitsbi2.png' sx={{ ml: 1, width: 30, height: 40 }} /> */}
              </Box>
              <Paper elevation={3} sx={{ m: 1, border: 1, borderColor: 'primary.main', borderRadius: 4 }}>
                <TableContainer>
                  <Table
                    sx={{
                      minWidth: 600,
                      maxWidth: 900,
                      background: 'background.paper',
                      '& thead th': { borderWidth: 1 },
                      '& tbody tr:last-child td': { borderBottom: 0 },
                    }}
                    aria-label='sticky table'>
                    <TableHead>
                      <TableRow sx={{ m: 0, p: 1 }}>
                        <TableCell align='center' sx={{ py: 1 }}>
                          <Typography variant='body1' color='inherit' style={{ fontWeight: 'bold' }}>
                            Version
                          </Typography>
                        </TableCell>
                        <TableCell align='center' sx={{ p: 0 }}>
                          <Typography variant='body1' color='inherit' style={{ fontWeight: 'bold' }}>
                            Description
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody sx={{ mt: 0 }}>
                      
                      <TableRow sx={{ m: 0, p: 1 }}>
                        <TableCell align='center' sx={{ py: 0.5 }}>
                          <Typography variant='body2' color='inherit'>
                            1.0
                          </Typography>
                        </TableCell>
                        <TableCell align='left' sx={{ py: 0.5 }}>
                          <Typography variant='body2' color='inherit'>
                            1ère version mise en place pour la <strong>saison 2025</strong>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>
          </Box>
        </Box>
    </Box>
  );
}

export default About;
